import { Pagination } from '@/shared/types/common';

export const getNextCursor = <TPage extends Partial<Pagination>>(lastPage?: TPage | null) =>
  lastPage?.pagination?.has_more ? { cursor: lastPage.pagination.next_cursor } : undefined;
